import { Group, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { ReactNode } from 'react';

interface Props {
  title?: ReactNode;
  description?: ReactNode;
  rightSection?: ReactNode;
  spacing?: number;
}

export default ({ description, rightSection, spacing = 30, title }: Props) => {
  const matches = useMediaQuery('(max-height: 600px)');

  return (
    <Group justify="space-between" gap={matches ? 10 : spacing} mt={matches ? 10 : 20} mb={matches ? 10 : 20}>
      <section>
        {typeof title === 'string' ? (
          <Text fz={matches ? 25 : 34} fw={500} c="gray.8">
            {title}
          </Text>
        ) : (
          <section>{title}</section>
        )}

        <Text size={matches ? 'sm' : 'md'} mt={matches ? 0 : 5} c="gray.6">
          {description}
        </Text>
      </section>
      <section>{rightSection}</section>
    </Group>
  );
};
